// Export all conversations
import aboutWorkConversation from './aboutWork';
import outsideWorkConversation from './outsideWork';
import systemsConversation from './systems';
import growthConversation from './growth';
import genaiConversation from './genai';
import projectsConversation from './projects';

const conversations = {
  aboutWork: aboutWorkConversation,
  outsideWork: outsideWorkConversation,
  systems: systemsConversation,
  growth: growthConversation,
  genai: genaiConversation,
  projects: projectsConversation
};

export default conversations;





